<template>
  <div class="main-container">
    <NavigationBar />
    <div id="box">
      <p class="main-title">Add SlashMap to your Slack workspace</p>
      <p class="main-subtitle">
        It is required to enable the "/map" command in Slack, avatars on the
        map, and username suggestions.
      </p>
    </div>
    <div id="options-box" class="columns is-desktop">
      <div class="column option-box-wrapper">
        <div class="ats-button-box">
          <div id="box" class="option-box">
            <div class="option-title">
              Do it yourself
            </div>
            <div class="option-body">
              <a href="/app/add-to-slack" style="background-color: white">
                <img
                  src="https://platform.slack-edge.com/img/add_to_slack.png"
                  alt="Add to Slack"
                  height="28"
                />
              </a>
              <br />
              (admin rights required)
            </div>
          </div>
        </div>
      </div>

      <div class="column option-box-wrapper">
        <div class="">
          <div id="box" class="option-box">
            <div class="option-title">
              Pass this link to the admin of your Slack team
            </div>
            <div class="option-body">
              <div id="url-box">
                https://slashmap.com/app/add-to-slack
              </div>
              <br />
              <a
                id="copy-button"
                class="secondary-button button"
                @click="copyToClipboard()"
              >
                Copy link to clipboard
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="column option-box-wrapper">
        <div class="">
          <div id="box" class="option-box">
            <div class="option-title">
              Skip for now
            </div>
            <div class="option-body">
              Skip and take a tour first. <br />
              <br />
              "Add to Slack" button will be available for you in the top bar.
              <br />
              <a class="secondary-button button" href="/app/floors">
                Go to the application &rarr;
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavigationBar from "@/components/NavigationBar.vue";

export default {
  name: "how-to-add",
  components: { NavigationBar },
  data() {
    return {};
  },
  computed: {},
  mounted: {},
  methods: {
    copyToClipboard: function() {
      console.log("copy");
      // Paste url to the clipboard.
      const el = document.createElement("textarea");
      el.value = "https://slashmap.com/app/add-to-slack";
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      // Rename button.
      document.getElementById("copy-button").innerHTML = "Link copied!";
    }
  }
};
</script>

<style scoped>
.main-title {
  padding-top: 130px;
  font-weight: 700;
  font-size: 2rem;
  color: #363636;
}
.main-subtitle {
  font-size: 1.1rem;
  font-weight: 700;
  color: #6b6b6b;
}
.option-title {
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 25px;
  min-height: 5rem;
  align-items: center;
  justify-content: center;
}

#options-box {
  max-width: 80%;
  margin-right: auto;
  margin-left: auto;
  padding: 30px;
  justify-content: space-between;
}

#url-box {
  max-width: 90%;
  margin-right: auto;
  margin-left: auto;
  padding: 10px;
  background-color: #f4f8fb;
  border-radius: 4px;
  color: #717171;
  word-wrap: break-word;
  font-size: 13px;
  text-align: left;
}

.secondary-button {
  color: #348feb;
  font-weight: 500;
  padding: 10px;
  margin: 10px;
  border: 0px;
  white-space: normal;
}

.secondary-button :hover {
  color: #1276db;
}

.option-box-wrapper {
  border: solid;
  border: 1px lightgray solid;
  border-radius: 4px;
  box-sizing: border-box;
  margin: 20px;
}

.option-box {
  padding: 30px;
}

@media (max-width: 768px) {
  .main-title {
    padding-top: 5vh;
  }
  .main-subtitle {
    padding-top: 3vh;
  }
  #box {
    padding-right: 20px;
    padding-left: 20px;
  }
  #options-box {
    max-width: 100%;
    padding: 30px;
  }
  .option-box-wrapper {
    margin-left: 0;
    margin-right: 0;
  }
  .option-box {
    padding-left: 0;
    padding-right: 0;
  }
  .option-title {
    min-height: 0;
  }
}

.option-body {
  font-size: 14px;
  font-weight: 500;
  color: gray;
  height: 100%;
}

.ats-button-box {
  align-items: center;
  vertical-align: auto;
}
</style>
